/* eslint-disable no-console */
// Stub Data
const stubSearchMessagesData = {
  total: '+30',
  matches: [
    {
      conversation_id: 2,
      directorName: 'Mariam',
      messageHtml:
        'To schedule a tour please use <a href="https://google.com" target="_blank" class="text-sky-500 underline">this link</a>. Let me know if you have any follow up questions',
    },
    {
      conversation_id: 3,
      directorName: 'Lauren',
      messageHtml:
        'Thank you for your enrollment application. I noticed your signature is missing on the enrollment document.',
    },
  ],
}

const stubConversationsData = [
  {
    id: 1,
    directorName: 'Sara',
    schoolId: 1,
    lastMessageText:
      'To schedule a tour please use this link. Let me know if you have any follow up questions',
  },
  {
    id: 2,
    directorName: 'Mariam',
    schoolId: 2,
    lastMessageText: 'How can I help?',
  },
  {
    id: 3,
    directorName: 'Lauren',
    schoolId: 3,
    lastMessageText: 'Sorry! I will sign it now.',
  },
]

const stubActiveConversations = {
  1: {
    id: 1,
    schoolId: 1,
    messages: [
      {
        user: 'You',
        messageHtml: 'Hello, how do I schedule an in person tour?',
      },
      {
        user: 'Director',
        messageHtml: 'Thank you for your interest',
      },
      {
        user: 'Director',
        messageHtml:
          'To schedule a tour please use <a href="https://google.com" target="_blank" class="text-sky-500 underline">this link</a>. Let me know if you have any follow up questions',
      },
    ],
  },
  2: {
    id: 2,
    schoolId: 2,
    messages: [
      {
        user: 'You',
        messageHtml: 'Hello, I had some questions about your teachers',
      },
      {
        user: 'Director',
        messageHtml: 'How can I help?',
      },
    ],
  },
  3: {
    id: 3,
    schoolId: 3,
    messages: [
      {
        user: 'Director',
        messageHtml:
          'Thank you for your enrollment application. I noticed your signature is missing on the enrollment document.',
      },
      {
        user: 'You',
        messageHtml: 'Sorry! I will sign it now.',
      },
    ],
  },
}

// Stub SDK

const parentMessagesSDKInstance = (_token, callbacks) => {
  let activeConversation

  return {
    getAllConversations: () => {
      setTimeout(() => {
        console.log('SDK - onConversationsLoad callback', stubConversationsData)
        callbacks.onConversationsLoad(stubConversationsData)
      }, 300)
    },
    selectActiveConversation: requestedId => {
      const localStorageKey = 'parentMessagesSDKActiveConversationId'
      const id =
        requestedId || window.localStorage.getItem(localStorageKey) || stubConversationsData[0].id

      activeConversation = stubActiveConversations[id]

      window.localStorage.setItem(localStorageKey, id)

      setTimeout(() => {
        console.log('SDK - onActiveConversationLoad callback', id)
        callbacks.onActiveConversationLoad(activeConversation)
      }, 700)
    },
    searchMessages: payload => {
      console.log('SDK - searchMessages callback', payload)

      // Make call to API to search and get results
      const results = stubSearchMessagesData

      setTimeout(() => {
        console.log('SDK - onSearchMessagesLoad callback')
        callbacks.onSearchMessagesLoad(results)
      }, 300)
    },
    sendMessage: payload => {
      console.log('SDK - sendMessage callback', payload, activeConversation)

      // Simulate data being saved in the database and an update being published to subscribers
      const messages = activeConversation.messages
      messages.push({ user: payload.user, messageHtml: payload.message })
      activeConversation.messages = messages

      callbacks.onActiveConversationLoad(activeConversation)
    },
  }
}

const parentMessagesSDK = {
  init: (token, callbacks) => {
    console.log(`INFO: Initialized parent messages SDK with token "${token}"`)

    return parentMessagesSDKInstance(token, callbacks)
  },
}

export default parentMessagesSDK
